export const DAYS_LEFT_WARNING_THRESHOLD = 4;
export const BALANCE_CRITICAL_THRESHOLD = 0;
